export const buildInstallSnippet = (publicKey: string): string => {
  if (!/^gs_pk_[a-z0-9_-]+$/i.test(publicKey)) {
    throw new Error('Invalid public tracking key');
  }
  const stage = publicKey.match(/^gs_pk_([a-z0-9-]+)_/)?.[1] ?? 'prod';
  const domain = stage === 'prod' ? 'gainsignal.ai' : `${stage}.gainsignal.ai`;
  const endpoint =
    stage === 'prod'
      ? ''
      : `, { endpoint: 'https://ingest.${domain}/v1/batch' }`;
  return `<script>
  (function(g,a,i,n){g.gain=g.gain||function(){(g.gain.q=g.gain.q||[]).push(arguments)};
  var s=a.createElement('script');s.async=1;s.src=i;
  a.head.appendChild(s)})(window,document,'https://cdn.${domain}/gain.js');

  gain('init', ${JSON.stringify(publicKey)}${endpoint});
</script>`;
};
